import { render, staticRenderFns } from "./new-tsl.vue?vue&type=template&id=b26b6e04&"
import script from "./new-tsl.vue?vue&type=script&lang=js&"
export * from "./new-tsl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports